<div class="flex-center">
  <div class="card rgba-black-light rounded loading-overlay-container" id="login-card">

    <div class="loading-overlay rounded animated align-items-start">
      <div class="progress transparent rounded">
        <div class="indeterminate lime darken-4"></div>
      </div>
    </div>

    <div class="card-body">

      <h4 class="card-title" translate>USER.LOGIN</h4>
      <div class="card-text">
        <form class="text-center" (ngSubmit)="onSubmit()" [formGroup]="loginForm" novalidate>
          <div class="form-group md-form">
            <i class="fa fa-key prefix"></i>
            <input type="text" id="code" name="invitationCode" class="form-control my-5" formControlName="code" minlength="6" maxlength="6"
              appFillFromParams="id" allowedChars="[a-zA-Z0-9]" required appLoginInput textWrong="{{'LOGIN.WRONG_CODE'|translate}}"
              textSuccess="{{'LOGIN.RIGHT_CODE'|translate}}">
            <label for="code">{{'LOGIN.CODE'|translate}}</label>
          </div>
          <input type="submit" value="{{'USER.LOGIN'|translate}}" class="btn btn-rounded mb-0 btn-outline-white" [disabled]="loginForm.invalid"
            [class.btn-outline-black]="loginForm.valid" [class.peach-gradient]="loginForm.valid">
        </form>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/components/login/login.component.html